import type { Bounty, BountyType } from '~/util/types/bounties';

const bountyTypeOrder: Record<BountyType, number> = {
    Event: 0,
    Weekly: 1,
    Monthly: 2,
    Bounty: 3,
};

export const isBountyActive = (bounty: Bounty, now = new Date()) =>
    !bounty.end_date || new Date(bounty.end_date) > now;

export const compareBountiesByDefault = (
    firstBounty: Bounty,
    secondBounty: Bounty,
    now = new Date(),
) => {
    const firstActive = isBountyActive(firstBounty, now);
    const secondActive = isBountyActive(secondBounty, now);

    if (firstActive && !secondActive) return -1;
    if (!firstActive && secondActive) return 1;

    if (firstActive && secondActive) {
        const typeComparison =
            bountyTypeOrder[firstBounty.bounty_type] -
            bountyTypeOrder[secondBounty.bounty_type];

        if (typeComparison !== 0) return typeComparison;
        return secondBounty.start_date.localeCompare(firstBounty.start_date);
    }

    return (secondBounty.end_date ?? '').localeCompare(
        firstBounty.end_date ?? '',
    );
};
